import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Importar useNavigate
import { useGet } from "../../customHooks/useGet";
import { useAuthProvider } from "../../customHooks/authContext";
import { usePost } from "../../customHooks/usePost";
import { Container, Table, Button, Modal, Form, Spinner, Alert, } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css"; // Asegúrate de importar Bootstrap
import { diploma_Base64 } from '../EventOrganization/Certificates/diploma_base64.js';
import "../EventOrganization/Fonts/Playball-Regular-bolditalic.js";

import { get } from "../../services/Services";
import { jsPDF } from "jspdf";
import { useLocation } from "react-router-dom";

const Registration = () => {
  const navigate = useNavigate(); // Hook para navegación
  const { school, token } = useAuthProvider();
  const location = useLocation();
  const { eventId } = location.state || {};
  const schoolId = school?.id;
  const { data: events, loading, error, registeredEvents } = useGet( //obtiene el id de school
    schoolId
      ? `https://ectech-software.com.ar/api/academy/events/available?schoolId=${schoolId}`
      : null
  );
  const [fetchSchools, setFetchSchools] = useState(false);
  const { data: schools } = useGet( //obtiene los datos de la escuela by idschool
    fetchSchools && schoolId
      ? `https://ectech-software.com.ar/api/academy/schools/${schoolId}`
      : null
  );

  const { executePost } = usePost();
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedSchool, setSelectedSchool] = useState("");
  const [showModal, setShowModal] = useState(false);


  const handleRegisterClick = (configId) => {
    setSelectedEvent(configId);
    setFetchSchools(schoolId);
    console.log(schoolId);
    console.log(configId);

    setShowModal(true);
  };

  const handleRegister = async () => {
    if (!selectedSchool) {
      alert("Por favor, selecciona una escuela.");
      return;
    }

    const registrationData = {
      status: true,
      school: { id: parseInt(selectedSchool) },
      eventConfig: { id: selectedEvent },
    };

    try {
      await executePost(
        "https://ectech-software.com.ar/api/academy/events/registration", // guarda el registro en la db
        registrationData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Registro exitoso");
      setShowModal(false);
      setFetchSchools(false);
      window.location.reload(); // Refresca la página para actualizar los botones
    } catch (error) {
      alert("Error al registrar la escuela en el evento");
      console.error(error);
    }
  };

  const handleGoToWorks = (eventRegistrationId, eventId) => {
    navigate(`/performance`, { state: { eventRegistrationId, eventId } }); // Redirige a la página de obras
  };

  const handleGoToPayments = (eventRegistrationId, configId) => {
    navigate(`/payments`, { state: { eventRegistrationId, configId } }); // Redirige a la página de pagos
  };

  const handleGoToCourses = (configId, eventRegistrationId) => {
    navigate(`/course`, { state: { configId, eventRegistrationId } }); // Redirige a la página de seminarios y congresos
  };

  const schoolsArray = Array.isArray(schools) ? schools : schools ? [schools] : [];



  return (
    <Container className="mt-4 pb-5">
      <h2 className="text-center fw-bold text-primary">Eventos Disponibles</h2>

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : error ? (
        <Alert variant="danger" className="text-center">
          Error al cargar eventos.
        </Alert>
      ) : events.length === 0 ? (
        <Alert variant="info" className="text-center">
          No hay eventos disponibles.
        </Alert>
      ) : (
        <div className="table-responsive">
          <Table striped bordered hover className="text-center table-striped table-hover table-bordered">
            <thead className="table-primary">
              <tr>
                <th>Nombre</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {events.map((event) => (
                <tr key={event.id}>
                  <td className="fw-bold">{event.name}</td>
                  <td>
                    <Button
                      variant="primary"
                      onClick={() => handleRegisterClick(event.configId)}
                      disabled={event.eventRegistrationId !== null}
                    >
                      Registrarse
                    </Button>
                    {event.eventRegistrationId !== null && (
                      <>
                        <Button
                          variant="success"
                          className="ms-2"
                          onClick={() => handleGoToWorks(event.eventRegistrationId, event.id)}
                        >
                          Obras
                        </Button>
                        <Button
                          variant="danger"
                          className="ms-2"
                          onClick={() => handleGoToCourses(event.configId, event.eventRegistrationId)}
                        >
                          Seminarios - Congresos
                        </Button>
                        <Button
                          variant="warning"
                          className="ms-2"
                          onClick={() => handleGoToPayments(event.eventRegistrationId, event.configId)}
                        >
                          Pagos
                        </Button>

                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}

      {/* Modal para registrar escuela */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Registrar Escuela</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="schoolSelect">
            <Form.Label className="fw-bold">Selecciona una escuela:</Form.Label>
            <Form.Select
              value={selectedSchool}
              onChange={(e) => setSelectedSchool(e.target.value)}
            >
              <option value="">-- Seleccionar --</option>
              {schoolsArray.length > 0 ? (
                schoolsArray.map((school) => (
                  <option key={school.id} value={school.id}>
                    {school.name}
                  </option>
                ))
              ) : (
                <option disabled>No hay escuelas disponibles.</option>
              )}
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleRegister}>
            Registrar
          </Button>
        </Modal.Footer>
      </Modal>


    </Container>
  );


};

export default Registration;
